(() => {
  const PRODUCT_CARD_PRIMARY_IMAGE_SELECTOR =
    '.product-card-wrapper .card__media .media > img:first-child[loading="lazy"]';

  let fallbackScheduled = false;

  const loadRemainingPrimaryImages = () => {
    fallbackScheduled = false;

    document.querySelectorAll(PRODUCT_CARD_PRIMARY_IMAGE_SELECTOR).forEach((image) => {
      image.removeAttribute('loading');
    });
  };

  const scheduleFallback = () => {
    if (fallbackScheduled) return;

    fallbackScheduled = true;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadRemainingPrimaryImages, { timeout: 2000 });
    } else {
      window.setTimeout(loadRemainingPrimaryImages, 800);
    }
  };

  const scheduleAfterPageLoad = () => {
    if (document.readyState === 'complete') {
      scheduleFallback();
      return;
    }

    window.addEventListener('load', scheduleFallback, { once: true });
  };

  scheduleAfterPageLoad();

  document.addEventListener('shopify:section:load', scheduleFallback);

  const productGridObserver = new MutationObserver((mutations) => {
    const productCardsAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('.product-card-wrapper, .product-grid') ||
            node.querySelector?.('.product-card-wrapper')),
      ),
    );

    if (productCardsAdded) scheduleFallback();
  });

  productGridObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
